// Tela 6 — linha de Agente Nominal (10 agentes ADR-036). Conversão verbatim de
// design-references/brief-3/shared/cards-3.jsx L1204-1217: markup/classes idênticos
// (agent-row, agent-row__name mono, num, mono). a.id→a.label (humanizado D8);
// accept null → "n/a" (degradação honesta).
//
// B-1 (17/Set/2026): a coluna de valor (`$a.cost`) saiu. Era o custo que a
// PLATAFORMA paga ao fornecedor de IA, renderizado em dólar na tela do
// supervisor do tenant — auditoria de escopo plataforma × tenant.
import type { AgentRowVM } from '../../view-models';
import type React from 'react';

export function AgentNominalRow({ a }: { a: AgentRowVM }): React.JSX.Element {
  return (
    <tr className="agent-row">
      <td className="agent-row__name mono">{a.label}</td>
      <td className="num">{a.inv.toLocaleString('pt-BR')}</td>
      <td className="num mono">{a.tokens}</td>
      <td className="num">
        {a.accept != null ? <b>{a.accept}%</b> : <span className="tweaks-hint">n/a</span>}
      </td>
      <td className="num mono">{a.lat}s</td>
    </tr>
  );
}
